import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { API_ENDPOINTS } from '../../shared/constants/constants';

export const createOrderContent = createAsyncThunk(
  'content/order/create',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.createOrderContent;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getOrderContent = createAsyncThunk(
  'content/order/get',
  async (orderId:any, {rejectWithValue}) => {
    let url = API_ENDPOINTS.fetchOrderContent;
    url = url.replace(":orderId", orderId)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const createGoodsReqChallanContent = createAsyncThunk(
  'content/grn/create',
  async (reqBody:any, {rejectWithValue}) => {
    const url = API_ENDPOINTS.createGRNContent;
    const { axiosPost } = useCustomAxios();
    try {
      const response = await axiosPost(url, reqBody);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getGoodsReqChallanContent = createAsyncThunk(
  'content/grn/get',
  async (grnId:any, {rejectWithValue}) => {
    let url = API_ENDPOINTS.fetchGRNContent;
    url = url.replace(":goodsReqChallanId", grnId)
    const { axiosGet } = useCustomAxios();
    try {
      const response = await axiosGet(url);
      return { data: response?.data, status: response?.status };
    } catch (error: any) {
      console.log(error)
      return rejectWithValue(error?.response?.data);
    }
  }
);
